(() => {
  const root = document.querySelector('[data-sp-videos]');

  if (!root) return;

  const hubTitle = root.dataset.hubTitle || document.title;
  const chips = Array.from(root.querySelectorAll('[data-sp-video-chip]'));
  const groups = Array.from(root.querySelectorAll('.sp-videos-group'));

  const headerOffset = () => {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--sp-header-height');
    const parsed = Number.parseFloat(raw);

    return Number.isFinite(parsed) ? parsed : 76;
  };

  const findWatch = (slug) => {
    if (!slug) return null;

    const escaped = window.CSS && CSS.escape ? CSS.escape(slug) : slug.replace(/"/g, '');

    try {
      return root.querySelector(`#${escaped}.sp-videos-watch`);
    } catch (error) {
      return null;
    }
  };

  const setActiveChip = (id) => {
    chips.forEach((chip) => {
      const on = chip.dataset.spVideoChip === id;

      chip.classList.toggle('is-active', on);

      if (on) {
        chip.setAttribute('aria-current', 'true');
        return;
      }

      chip.removeAttribute('aria-current');
    });
  };

  const stopHiddenWatchPlayers = () => {
    root.querySelectorAll('.sp-videos-watch:not(.is-active) [data-sp-video-frame]').forEach((frame) => {
      if (!frame.innerHTML) return;

      frame.hidden = true;
      frame.innerHTML = '';

      const poster = frame.closest('[data-sp-video-card]')?.querySelector('[data-sp-video-play]');

      if (poster) poster.hidden = false;
    });
  };

  const syncChipsFromScroll = () => {
    if (root.classList.contains('is-watching') || !groups.length) return;

    const line = headerOffset() + 72;
    let current = 'all';

    groups.forEach((group) => {
      if (group.getBoundingClientRect().top <= line) current = group.id;
    });

    setActiveChip(current);
  };

  const syncHash = ({ focusHeading = false } = {}) => {
    const slug = window.location.hash.replace(/^#/, '');
    const watchBase = root.dataset.videoWatchBase || '';

    if (
      watchBase &&
      slug &&
      slug !== 'sp-videos-hub' &&
      !slug.startsWith('group-')
    ) {
      window.location.replace(`${watchBase}${encodeURIComponent(slug)}`);
      return;
    }

    const watch = findWatch(slug);

    root.querySelectorAll('.sp-videos-watch.is-active').forEach((panel) => {
      panel.classList.remove('is-active');
    });

    root.classList.toggle('is-watching', Boolean(watch));

    if (watch) {
      watch.classList.add('is-active');
      document.title = watch.dataset.pageTitle || hubTitle;
      window.scrollTo(0, 0);
      stopHiddenWatchPlayers();

      if (focusHeading) {
        watch.querySelector('.sp-videos-watch__heading')?.focus({ preventScroll: true });
      }

      return;
    }

    document.title = hubTitle;
    stopHiddenWatchPlayers();

    if (slug.startsWith('group-') && document.getElementById(slug)) {
      setActiveChip(slug);
      chips
        .find((chip) => chip.dataset.spVideoChip === slug)
        ?.scrollIntoView({ inline: 'center', block: 'nearest' });
      return;
    }

    syncChipsFromScroll();
  };

  let ticking = false;

  window.addEventListener(
    'scroll',
    () => {
      if (ticking || root.classList.contains('is-watching')) return;

      ticking = true;
      requestAnimationFrame(() => {
        syncChipsFromScroll();
        ticking = false;
      });
    },
    { passive: true }
  );

  syncHash();
  window.addEventListener('hashchange', () => syncHash({ focusHeading: true }));
  window.addEventListener('load', () => syncHash());
})();
